import * as React from "react";

import { Modal } from "../../../components";

const constructionImg = require("../assets/under-construction.png");

export interface ModalProps {
  handleClose: () => void;
  isOpen: boolean;
}

const OrderModal = (props: ModalProps) => (
  <Modal {...props}>
    <div className="under-construction-modal">
      <h3 className="text-center">Dashboard</h3>
      <p className="text-center">
        Dashboard khách hàng đang trong giai đoạn hoàn thiện. <br />
        Vui lòng kiểm tra email của bạn cho thông tin về đơn đặt hàng sản phẩm.
      </p>
      <img className="img-responsive" src={constructionImg} />
      <button className="close-btn" onClick={props.handleClose}>
        OK
      </button>
    </div>
  </Modal>
);

export default OrderModal;



// WEBPACK FOOTER //
// ./src/routes/OrderSuccess/components/Modal.tsx